import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  CURRENCIES = [
    {slug: 'usd', symbol: '$'},
    {slug: 'bgn', symbol: 'лв'},
    {slug: 'kzt', symbol: 'KZT'},
    {slug: 'kgs', symbol: 'KGS'},
    {slug: 'uzs', symbol: 'UZS'},
    {slug: 'rsd', symbol: 'Дин.'},
    {slug: 'mkd', symbol: 'ден'},
    {slug: 'pln', symbol: 'zł'},
    {slug: 'zwd', symbol: 'Z$'},
    {slug: 'ttd', symbol: 'TT$'},
    {slug: 'pen', symbol: 'S/.'},
    {slug: 'sos', symbol: 'S'},
    {slug: 'idr', symbol: 'Rp'},
    {slug: 'myr', symbol: 'RM'},
    {slug: 'dop', symbol: 'RD$'},
    {slug: 'brl', symbol: 'R$'},
    {slug: 'zar', symbol: 'R'},
    {slug: 'gtq', symbol: 'Q'},
    {slug: 'byr', symbol: 'p.'},
    {slug: 'bwp', symbol: 'P'},
    {slug: 'twd', symbol: 'NT$'},
    {slug: 'mzn', symbol: 'MT'},
    {slug: 'ltl', symbol: 'Lt'},
    {slug: 'lvl', symbol: 'Ls'},
    {slug: 'all', symbol: 'Lek'},
    {slug: 'ron', symbol: 'lei'},
    {slug: 'hnl', symbol: 'L'},
    {slug: 'dkk', symbol: 'DKK'},
    {slug: 'eek', symbol: 'EEK'},
    {slug: 'isk', symbol: 'ISK'},
    {slug: 'nok', symbol: 'NOK'},
    {slug: 'sek', symbol: 'SEK'},
    {slug: 'hrk', symbol: 'kn'},
    {slug: 'bam', symbol: 'KM'},
    {slug: 'czk', symbol: 'Kč'},
    {slug: 'jmd', symbol: 'J$'},
    {slug: 'pyg', symbol: 'Gs'},
    {slug: 'awg', symbol: 'AWG'},
    {slug: 'ang', symbol: 'ANG'},
    {slug: 'huf', symbol: 'Ft'},
    {slug: 'chf', symbol: 'CHF'},
    {slug: 'nio', symbol: 'C$'},
    {slug: 'bzd', symbol: 'BZ$'},
    {slug: 'vef', symbol: 'Bs'},
    {slug: 'pab', symbol: 'B/.'},
    {slug: 'irr', symbol: 'IRR'},
    {slug: 'omr', symbol: 'OMR'},
    {slug: 'qar', symbol: 'QAR'},
    {slug: 'sar', symbol: 'SAR'},
    {slug: 'yer', symbol: 'YER'},
    {slug: 'mur', symbol: 'MUR'},
    {slug: 'npr', symbol: 'NPR'},
    {slug: 'pkr', symbol: 'PKR'},
    {slug: 'scr', symbol: 'SCR'},
    {slug: 'lkr', symbol: 'LKR'},
    {slug: 'gel', symbol: '₾'},
    {slug: 'rub', symbol: '₽'},
    {slug: 'azn', symbol: '₼'},
    {slug: 'try', symbol: '₺'},
    {slug: 'inr', symbol: '₹'},
    {slug: 'uah', symbol: '₴'},
    {slug: 'cup', symbol: 'CUP'},
    {slug: 'php', symbol: 'PHP'},
    {slug: 'mnt', symbol: '₮'},
    {slug: 'lak', symbol: '₭'},
    {slug: 'eur', symbol: '€'},
    {slug: 'vnd', symbol: '₫'},
    {slug: 'ils', symbol: '₪'},
    {slug: 'kpw', symbol: 'KPW'},
    {slug: 'krw', symbol: 'KRW'},
    {slug: 'ngn', symbol: '₦'},
    {slug: 'crc', symbol: '₡'},
    {slug: 'khr', symbol: '៛'},
    {slug: 'thb', symbol: '฿'},
    {slug: 'afn', symbol: '؋'},
    {slug: 'cny', symbol: 'CNY'},
    {slug: 'jpy', symbol: '¥'},
    {slug: 'egp', symbol: 'EGP'},
    {slug: 'fkp', symbol: 'FKP'},
    {slug: 'gip', symbol: 'GIP'},
    {slug: 'ggp', symbol: 'GGP'},
    {slug: 'imp', symbol: 'IMP'},
    {slug: 'jep', symbol: 'JEP'},
    {slug: 'lbp', symbol: 'LBP'},
    {slug: 'shp', symbol: 'SHP'},
    {slug: 'syp', symbol: 'SYP'},
    {slug: 'gbp', symbol: '£'},
    {slug: 'uyu', symbol: '$U'},
    {slug: 'bob', symbol: '$b'},
    {slug: 'ars', symbol: 'ARS'},
    {slug: 'aud', symbol: 'AUD'},
    {slug: 'bsd', symbol: 'BSD'},
    {slug: 'bbd', symbol: 'BBD'},
    {slug: 'bmd', symbol: 'BMD'},
    {slug: 'bnd', symbol: 'BND'},
    {slug: 'cad', symbol: 'CAD'},
    {slug: 'kyd', symbol: 'KYD'},
    {slug: 'clp', symbol: 'CLP'},
    {slug: 'cop', symbol: 'COP'},
    {slug: 'xcd', symbol: 'XCD'},
    {slug: 'svc', symbol: 'SVC'},
    {slug: 'fjd', symbol: 'FJD'},
    {slug: 'gyd', symbol: 'GYD'},
    {slug: 'hkd', symbol: 'HKD'},
    {slug: 'lrd', symbol: 'LRD'},
    {slug: 'mxn', symbol: 'MXN'},
    {slug: 'nad', symbol: 'NAD'},
    {slug: 'nzd', symbol: 'NZD'},
    {slug: 'sgd', symbol: 'SGD'},
    {slug: 'sbd', symbol: 'SBD'},
    {slug: 'srd', symbol: 'SRD'},
    {slug: 'tvd', symbol: 'TVD'},
    {slug: 'ghc', symbol: '¢'},
    {slug: 'aed', symbol: 'AED'},
    {slug: 'mad', symbol: 'MAD'},
    {slug: 'aoa', symbol: 'AOA'},
    {slug: 'kes', symbol: 'KES'},
  ];

  constructor() {}

  getBySlug(slug: string) {
    return this.CURRENCIES.find((currency: { slug: string, symbol: string }) => currency.slug === slug);
  }

  findCurrencies() {
    return this.CURRENCIES;
  }
}
